module.exports = __webpack_public_path__ + "img/purchase_1.d2aeee3b.svg";